import { Body, Controller, Post } from "@nestjs/common";
import { ApiTags } from "@nestjs/swagger";
import { FgPriceListService } from "./fg-pricelist-service";
import { FgPriceListRequest, FgPriceListRequestDto, FgPriceListResponseModel, ProductAndCategoryReq } from "@gtpl/shared-models/masters";
import { ApplicationExceptionHandler } from "@gtpl/shared-utils/error-messages";
import { CommonResponse } from "@gtpl/shared-models/production-management";

@ApiTags('fg-pricelist')
@Controller('fg-pricelist')
export class FgPriceListController{
    constructor(
        private fgPriceListService:FgPriceListService,
        private readonly applicationExceptionhandler: ApplicationExceptionHandler,

    ){}
    @Post('/createFgPriceList')
    async createFgPriceList(@Body() req:FgPriceListRequestDto):Promise<FgPriceListResponseModel>{
        console.log(req,'pppppppppppppppp');
        
        try{
            return await this.fgPriceListService.createFgPriceList(req)
        }catch(err){
            return this.applicationExceptionhandler.returnException(FgPriceListResponseModel,err)
        }
    }
    @Post('/getAllFgPriceListInfo')
    async getAllFgPriceListInfo():Promise<FgPriceListResponseModel>{
        try{
            return await this.fgPriceListService.getAllFgPriceListInfo()
        }catch(err){
            return this.applicationExceptionhandler.returnException(FgPriceListResponseModel,err)
        }
    }

    @Post('/getProductPriceByProductAndCategory')
    async getProductPriceByProductAndCategory(@Body() req:ProductAndCategoryReq):Promise<CommonResponse>{
        try{
            return await this.fgPriceListService.getProductPriceByProductAndCategory(req)
        }catch(err){
            return this.applicationExceptionhandler.returnException(FgPriceListResponseModel,err)
        }
    }
}